export default __webpack_public_path__ + "static/media/payment_QR-code.b0cc1ed8.jpg";